import { render, staticRenderFns } from "./TermsPop2.vue?vue&type=template&id=24ac9752&"
import script from "./TermsPop2.vue?vue&type=script&lang=ts&"
export * from "./TermsPop2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports